export const StepForward = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <path d="M9.375 20.625V9.375H11.25V20.625H9.375ZM13.125 20.625L22.5 15L13.125 9.375V20.625ZM15 17.3203V12.6797L18.8672 15L15 17.3203Z" />
    </svg>
  );
};
